// The built-in themes. Admin-made custom themes (D-047) were retired in D-184; occasion packs (D-180) do dated looks.
/** D-201: DIGU Classic is the default. D-204: it has a light mode ("classic-light"), and "auto" (a pref value, not a
 * theme) follows the device: Classic light when the phone is light, Classic when it is dark. */
export const BUILTIN_THEMES = ["classic", "classic-light", "ink", "seaglass", "lagoon", "afterhours", "reed"];
export const isBuiltinTheme = (id) => BUILTIN_THEMES.includes(id);
//# sourceMappingURL=themes.js.map